<template>
    <div class="container">
        <div class="row"  v-if="user.user_type_id!=3 || (user.user_type_id==3 && user.is_certyficated)">
            <div class="col col-4">
                <h2 class="h h--2 h--dark">Wypożyczone narzędzia</h2>
                <p class="paragraph">Twoje aktualnie wypożyczone narzędzia wraz z terminem zwrotu</p>
            </div>
            <div class="col col-8">
                <table class="invoices__table" v-if="tools.length > 0">
                    <tr>
                        <th width="80">ID</th>
                        <th>Opis</th>
                        <th>Termin oddania</th>
                    </tr>
                    <tr v-for="(tool, index) in tools">
                        <td>{{ tool.id }}</td>
                        <td>{{ tool.short_description }}</td>
                        <td>{{ tool.time_to }}</td>
                    </tr>
                </table>
                <div class="row profile" v-if="tools.length == 0">
                    <div class="col col-12">
                        <p>brak narzędzi</p>
                    </div>
                </div>
            </div>
        </div>

        <page-box-set-widget></page-box-set-widget>
    </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'MyToolsComponent',
  data () {
    return {
      tools: []
    }
  },
  beforeRouteEnter(to, from, next) {
    /**
     * Get current user object.
     */
    Vue.axios({
    method: 'get',
    url: '/users/dates'
    })
    .then(response => {
      next(vm => {
          vm.tools = response.data.data.dates.filter( x => x.title == "Wypożyczenie narzędzi" )
      })
    })
    .catch(error => next(false))
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  mounted: function() {
    if( !this.user || this.user.id != 1 ) {
        this.$gtag.pageview({
            page_path: '/wypozyczone-narzedzia',
        })
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/app/home/tools/MyToolsComponent.vue